





























































































import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";
import GGProductRating from "../GGProductRating/GGProductRating.vue";
import GGColorAvatar from "../../grid-generation/GGColorAvatar.vue";
import { type PropType, defineComponent } from "vue-demi";
import { declination } from "@artmizu/utils";
import type { PromoReview } from "@constructor/shared-entity/type";

export default defineComponent({
  name: "GGReviewCard",
  components: {
    GGProductRating,
    GGColorAvatar,
  },
  props: {
    data: {
      type: Object as PropType<PromoReview>,
      required: true,
    },
  },
  computed: {
    formattedDate() {
      return format(
        parse(this.data.date, "d.LL.yyyy HH:mm:ss", new Date()),
        "d MMMM yyyy",
        { locale: ru }
      );
    },
    declOfNumGoods() {
      return `${this.data.product.reviewCount} ${declination(
        this.data.product.reviewCount,
        ["отзыв", "отзыва", "отзывов"]
      )}`;
    },
  },
});
